import css from "standard/css";

const style = css`
  .figure {
    border-radius: var(--border-radius-circular);
    border: var(--border-width-thick) solid #3181B2;
  }

  .figure__avatar {
    aspect-ratio: 1 / 1;
    border: none;
    border-radius: var(--border-radius-circular);
    color: transparent;
    height: 42px;
    width: 42px;
    background-color: var(--color-master-light);
    object-fit: cover;
    object-position: top center;
    display: block;
    cursor: pointer;
  } 
`;

export default style;
